export const generateSupportSEO = () => {
  return {
    title: "Support | Lown",
    description: "Get help with Lown: setup, FAQs, troubleshooting, and contact options.",
    keywords: "Lown support, help, FAQ, troubleshooting, contact, loan calculator help, mortgage app support",
    url: "https://www.lown.app/support"
  };
};

export const generateFAQSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do I need to link my bank accounts?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Lown works without third-party aggregators. You input your details manually to stay in control of your data."
        }
      },
      {
        "@type": "Question",
        "name": "Can I track multiple loans?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Add and manage multiple saved loans including mortgages, auto, or personal."
        }
      },
      {
        "@type": "Question",
        "name": "Does Lown work offline?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Calculators and saved data work offline."
        }
      },
      {
        "@type": "Question",
        "name": "How accurate are the calculations?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Lown uses industry-standard formulas like amortization schedules and DTI ratios. Actual lender terms may vary."
        }
      }
    ]
  };
};
